import {Plural, Trans} from '@lingui/macro';
import React, {FC, ReactNode, useState} from 'react';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {CustomFieldModel} from '../../../../models/api/customFieldModel';
import {SettingsCustomFieldsPagesEnum} from '../../../../models/url/settingsUrlModel';
import {CustomFieldsDeleteDialog} from '../../dialog/customFieldsDeleteDialog';

/*
 * Props.
 */

interface CustomFieldsTableMultiSelectDeleteActionProps {
  customFields: ReadonlyArray<CustomFieldModel>;
  tabPage: SettingsCustomFieldsPagesEnum;
  onDeleteCustomFields: HandlerOf<ReadonlyArray<number>>;
  onSuccessfulDelete: HandlerOf<ReactNode>;
}

/*
 * Component.
 */

export const CustomFieldsTableMultiSelectDeleteAction: FC<CustomFieldsTableMultiSelectDeleteActionProps> = (
  props,
) => {
  const {customFields, tabPage, onDeleteCustomFields, onSuccessfulDelete} = props;
  const [isShowingConfirmationDialog, setIsShowingConfirmationDialog] = useState(false);

  return (
    <>
      <Button
        variant={ButtonVariantsEnum.SECONDARY_DANGER}
        onClick={() => setIsShowingConfirmationDialog(true)}
      >
        <Trans id="custom-fields-table-multi-select-delete">Delete</Trans>
      </Button>
      {isShowingConfirmationDialog && (
        <CustomFieldsDeleteDialog
          customFields={customFields}
          tabPage={tabPage}
          onClose={() => setIsShowingConfirmationDialog(false)}
          onDelete={() => {
            onDeleteCustomFields(customFields.map((customField) => customField.id));
            onSuccessfulDelete(renderSuccessMessage(customFields));
          }}
        />
      )}
    </>
  );
};

/*
 * Helpers.
 */

function renderSuccessMessage(customFields: ReadonlyArray<CustomFieldModel>) {
  return (
    <Plural
      id="delete-custom-fields-success"
      value={customFields.length}
      one={`Deleted "${customFields[0].name}" custom field`}
      other="Deleted # custom fields"
    />
  );
}
